import Vue from 'vue'
import App from './App.vue'
import router from './router.js'

import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
import './assets/Main.css'

Amplify.configure(aws_exports);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
